import { Box, Button, TextField, Typography, useMediaQuery, useTheme} from "@mui/material"
import SoopraLogo from "../../svg/SoopraLogo"
import { useState } from "react";
import { toast } from "react-toastify";
import EmailSubscribeBox from "../../component/EmailSubscribeBox";


const NextContest = () => {
    const showEmailInput = true
    const [stayUpdatedInput, setStayUpdatedInput] = useState<string>("")
    const theme = useTheme();

    const isXs = useMediaQuery(theme.breakpoints.down('sm'));
    const handleSubmitForm = () => {
        console.log(stayUpdatedInput)
        setStayUpdatedInput('')
        toast.success('We will keep you updated!')
    }
    
  return (
    <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            pb: {xs: 3, md: 0},
            py: {xs:3, md: 5},
            backgroundColor: (theme) => theme.palette.background["container-4"],
        }}
    >
        <Box 
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap:3,
                textAlign: "center",
            }}
        >
            <Typography variant={"h4"} color="text.primary" sx={{ fontWeight: 'bold' }}>
                🚀 Next Contest Coming Soon!
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ maxWidth: '600px', lineHeight: 1.6 }}>
                We had so much fun, we are planning to have another contest in the near future. Sign up to receive emails so you don't miss it!
            </Typography>
        </Box>
        {showEmailInput && 
            <Box
                sx={{
                    py: 2,
                    width: {xs:'90%', md:'55%', lg: '40%'},
                    maxWidth: '500px'
                }}
            >
                <EmailSubscribeBox 
                    formType="contest"
                    title=""
                    subtitle="No spam, unsubscribe anytime. Contest updates only."
                />
            </Box>
        }

    </Box>
  )
}

export default NextContest